import { Component, input, output, signal } from '@angular/core';
import { AnimationEvent } from '@angular/animations';
import { slideInOut } from './snackbar.animations';
import { IconComponent } from '@outlaw/icons';

@Component({
  selector: 'outlaw-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  animations: [slideInOut],
  imports: [IconComponent],
})
export class SnackbarComponent {
  message = input<string>('');
  animationDone = output<void>();
  isVisible = signal(true);

  hide() {
    this.isVisible.set(false);
  }

  onAnimationDone(event: AnimationEvent) {
    if (event.toState === 'void') {
      this.animationDone.emit();
    }
  }
}
